import React from 'react';

export const formatTextWithLinebreaks = str =>
  str.split('\n').map((item, index) => (
    <React.Fragment key={index}>
      {item}
      <br />
    </React.Fragment>
  ));

export const formatTextAsParagraphs = str =>
  str.split('\n').map((item, index) => <p key={index}>{item}</p>);
